import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {StringUtil} from "../../../util/string.util";
import {isEqual} from "lodash";
import {Config} from "../../../common/config";
import {ImageUtil} from "../../../util/image.util";
import {Constant} from '../../../common/constant';
import {OrderStatusHelper} from '../../../enums/order.status';

@Component({
  selector: 'app-frontend-table',
  standalone: false,
  templateUrl: './frontend-table.component.html',
  styleUrls: ['./frontend-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FrontendTableComponent {
  @Input()
  tableProperties = {
    offset: 0,
    limit: 7,
    pageLength: 0,
    limitOptions: [7, 14, 28],
    onSortChanged: (event: any) => {
    },
    pageChanged: (event: any) => {
    }
  };
  @Input()
  isMultiSelectable = false;
  @Input()
  isSelectable = false;
  @Input()
  displayColumns: string[] = [];
  @Input()
  displayColumnTypes: string[] = [];
  @Input()
  displayColumnEndpoints: string[] = [];
  @Input()
  dataSource: any[] = [];
  @Input()
  displayDataSources: string[] = [];
  @Input()
  selectedRows: any[] = [];
  @Input()
  hasPagination = true;
  @Input()
  showFirstLastButtons = true;
  @Input()
  statusColorMaps: Record<string, Record<string, string>> = {
    order: {
      SUBMIT: '#6c757d',
      PENDING_PAYMENT: '#ff9800',
      PROGRESSING: '#2196f3',
      PREPARATION: '#673ab7',
      PROCESSING_CENTER: '#009688',
      DELIVERY_DISPATCHER: '#3f51b5',
      DELIVERED: '#4caf50',
      CANCELED: '#f44336',
      CANCELED_BY_SYSTEM: '#b71c1c',
    },
    payment: {
      UNPAID: '#f44336',
      PARTIAL: '#ff9800',
      PAID: '#4caf50',
      REFUNDED: '#9c27b0',
    }
  };
  @Output()
  onSortChanged: EventEmitter<any> = new EventEmitter();
  @Output()
  onRowSelected: EventEmitter<any> = new EventEmitter();
  @Output()
  onRowsSelected: EventEmitter<any[]> = new EventEmitter();

  ngOnInit() {
    if (Config.permissions) {
      for (let i = this.displayColumnTypes.length - 1; i >= 0; i--) {
        if (this.displayColumnTypes[i] === 'event') {
          if (this.displayColumnEndpoints[i]) {
            if (!((Config.permissions ?? []).some((permission: any) => {
              return `/${Constant.FOOD_SHOP}${this.displayColumnEndpoints[i]}` === (permission.EndPoint ?? '');
            }))) {
              this.displayColumns.splice(i, 1);
              this.displayColumnEndpoints.splice(i, 1);
              this.displayColumnTypes.splice(i, 1);
              this.displayDataSources.splice(i, 1);
            }
          }
        }
      }
    }
  }

  getStatusColorFor(columnIndex: number, value: string): string {
    const typeToken = this.displayColumnTypes?.[columnIndex] ?? 'status';
    const family = (typeToken.split(':')[1] || 'order').trim();
    const map = this.statusColorMaps[family] ?? {};
    return map[value] ?? OrderStatusHelper.getStatusColor(value) ?? '#6c6c6c';
  }

  getValue(columnIndex: number, rowIndex: number, element: any, fieldName: string): any {
    let totalValue = '';
    for (let i = 0; i < fieldName.split('+').length; i++) {
      let value = element;
      for (let j = 0; j < fieldName.split('+')[i].split('.').length; j++) {
        if (Array.isArray(value)) {
          if (value && value.length > 0) {
            for (let k = 0; k < value.length; k++) {
              let temp: any = value[i];
              value = temp[fieldName.split('+')[i].split('.')[j]];
            }
          }
        } else {
          if (value !== undefined && value !== null) {
            value = value[fieldName.split('+')[i].split('.')[j]];
          }
        }
      }
      if (value !== undefined && value !== null) {
        totalValue += (' ' + value);
      }
    }
    totalValue = totalValue.trim();
    switch (this.displayColumnTypes[columnIndex]) {
      case 'string':
        return totalValue;
      case 'boolean':
        return (totalValue === 'true' ? 'بلی' : 'خیر');
      case 'number':
        return totalValue;
      case 'date':
        return totalValue;
      case 'business':
        return this.getBusinessTitle(totalValue.trim());
      case 'icon':
        return totalValue;
      case 'status':
        return totalValue;
      case 'row_number':
        return '' + ((this.tableProperties!.offset * this.tableProperties!.limit) + (rowIndex + 1));
      default:
        return totalValue;
    }
  }

  formatImage(imageId: string) {
    return ImageUtil.formatImage('', imageId);
  }

  numberAsCurrency(integer?: number) {
    return StringUtil.numberAsCurrency(integer);
  }

  onRowClicked(row: any) {
    if (this.isSelectable) {
      if (!this.isMultiSelectable) {
        this.selectedRows = [];
      }
      let index = -1;
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (isEqual(this.selectedRows[i], row)) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.selectedRows.splice(index, 1);
      } else {
        this.selectedRows.push(row);
      }
      if (this.isMultiSelectable) {
        this.onRowsSelected.emit(this.selectedRows);
      } else {
        if (this.selectedRows.length === 0) {
          this.onRowSelected.emit(undefined);
        } else {
          this.onRowSelected.emit(row);
        }
      }
    }
  }

  isIncluded(object: any): boolean {
    for (let i = 0; i < this.selectedRows.length; i++) {
      if (isEqual(this.selectedRows[i], object)) {
        return true;
      }
    }
    return false;
  }

  tableSortChange(event: any) {
    event.active = this.displayDataSources[this.displayColumns.indexOf(event.active)];
    if (this.tableProperties) {
      this.tableProperties.onSortChanged(event);
    } else {
      this.onSortChanged.emit(event);
    }
  }

  getBusinessTitle(businessId: string) {
    if (businessId !== undefined && Config.businesses !== undefined) {
      for (let i = 0; i < Config.businesses.length; i++) {
        if (businessId === Config.businesses[i].BusinessId) {
          return Config.businesses[i].Title;
        }
      }
    }
    return '';
  }

  getStatusColor(status: string): string {
    // استفاده از OrderStatusHelper برای دریافت رنگ وضعیت
    return OrderStatusHelper.getStatusColor(status);
  }
}
